import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@streamr/tv-ui';
import styled from 'styled-components';
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
/**
 * Over the player: the viewing failure ("this connection cannot carry even
 * the low-quality stream") with the required bandwidth and a retry, and
 * the lighter captions while switching down or retrying.
 */
export function SlowConnectionNotice() {
    const quality = StreamrAppService.getOutput().useContentQuality();
    if (!quality)
        return null;
    const failure = quality.failure;
    if (failure) {
        return (_jsx(NoticeRoot, { role: "alert", "data-automation-id": "slow-connection", children: _jsxs(NoticeCard, { children: [_jsx(NoticeTitle, { children: "Viewing the stream failed because of slow internet connection." }), _jsxs(NoticeBody, { children: ["Please connect using a faster internet connection. Viewing the stream requires at least", ' ', failure.minDownlinkMbps, " Mbps downlink and", ' ', failure.minUplinkMbps, " Mbps uplink bandwidth."] }), _jsx(Button, { type: "button", onClick: () => {
                            StreamrAppService.getNotificationInterface().notifyRetryContentViewing();
                        }, children: "Retry now" })] }) }));
    }
    if (quality.recovering) {
        return (_jsx(NoticeRoot, { children: _jsx(Caption, { children: "Retrying\u2026" }) }));
    }
    if (quality.switching === 'down') {
        return (_jsx(NoticeRoot, { children: _jsx(Caption, { children: "Switching to low quality\u2026" }) }));
    }
    return null;
}
const NoticeRoot = styled.div `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    pointer-events: none;
    z-index: 5;

    > * {
        pointer-events: all;
    }
`;
const NoticeCard = styled.div `
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-width: 24rem;
    padding: 1.25rem 1.5rem;
    border-radius: 1rem;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(1rem);
    color: #fff;
    text-align: center;
    align-items: center;
`;
const NoticeTitle = styled.div `
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.4;
`;
const NoticeBody = styled.div `
    font-size: 0.875rem;
    line-height: 1.4;
`;
const Caption = styled.div `
    padding: 0.375rem 0.75rem;
    border-radius: 1rem;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(0.5rem);
    color: #fff;
    font-size: 0.875rem;
`;
